import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box, Button, Typography, Container } from "@mui/material";
import { MotionContainer, varBounceIn } from "../components/animate";
import Page from "../components/Page";
import Translate from "../utils/Translate";

const RootStyle = styled(Page)(({ theme }) => ({
  display: "flex",
  minHeight: "100%",
  alignItems: "center",
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));

export default function ErrorPage() {
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const errorCode = params.get("code");

  let errorTitle;
  let errorMessage;
  switch (errorCode) {
    case "entra_auth_failed":
      errorTitle = Translate.get("SomethingFailed");
      errorMessage = Translate.get("EntraAuthFailed");
      break;
    default:
      errorTitle = null;
      errorMessage = null;
      break;
  }

  const handleGoHome = () => {
    window.location.href = "/";
  };

  if (!errorTitle || !errorMessage) {
    handleGoHome();
    return null;
  }

  return (
    <RootStyle title="Error">
      <Container>
        <MotionContainer initial="initial" open>
          <Box sx={{ maxWidth: 480, margin: "auto", textAlign: "center" }}>
            <Typography variant="h3" paragraph>
              {errorTitle}
            </Typography>
            <Typography sx={{ color: "text.secondary", mb: 5 }}>{errorMessage}</Typography>
            <Button size="large" variant="contained" onClick={handleGoHome}>
              {Translate.get("GoToDashboard")}
            </Button>
          </Box>
        </MotionContainer>
      </Container>
    </RootStyle>
  );
}
